import { QuestionValidator, ValidationStatus } from '../types';
import AnswerValidationResult from '../valueObjects/AnswerValidationResult';
import { createValidationMessage } from '../helpers';

export default (
  questionId: string,
  answerValue: string,
  validatorFunction: QuestionValidator,
  forceValidation = false
): AnswerValidationResult => {
  try {
    const validationResult = validatorFunction(forceValidation, answerValue);

    const questionErrors = validationResult ?? [];

    const isValid = !questionErrors.length;

    const questionValidationStatus = isValid ? ValidationStatus.OK : ValidationStatus.Error;

    const messages = questionErrors
      .filter(questionError => questionError !== null)
      .map(questionError =>
        createValidationMessage(questionError?.detail, questionError.questionId, 'error', questionId)
      );

    return new AnswerValidationResult(questionValidationStatus, messages);
  } catch (err) {
    const message = `js err: question #${questionId} - ${(err as Error).message}`;

    // eslint-disable-next-line no-console
    console.error('Validation:', message);

    return new AnswerValidationResult(ValidationStatus.Error, [
      createValidationMessage(message, undefined, undefined, questionId),
    ]);
  }
};
